import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notificationSubject = new Subject<any>();
  notificationDateSubject = new Subject<any>();

  constructor() { }

  newNotification(value: any): void {
    this.notificationSubject.next(value);
  }
}
